import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19b8ab52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-field" }
const _hoisted_2 = {
  key: 0,
  class: "input-field__label"
}
const _hoisted_3 = {
  key: 1,
  class: "input-field__search-icon bx bx-search text-md",
  "data-ts": "search-icon"
}
const _hoisted_4 = ["value", "aria-label", "placeholder", "type", "disabled", "min"]
const _hoisted_5 = {
  key: 2,
  class: "input-field__loading",
  "data-ts": "loading-label"
}
const _hoisted_6 = {
  key: 3,
  class: "input-field__error",
  "data-ts": "error-label"
}
const _hoisted_7 = ["title", "aria-label", "data-ts"]

import { ref } from 'vue';

type inputType = 'text' | 'email' | 'number';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
    type: {},
    value: {},
    placeholder: {},
    label: {},
    disabled: { type: Boolean },
    hasError: { type: Boolean },
    errorLabel: {},
    ariaLabel: {},
    isSearch: { type: Boolean },
    showClearBtn: { type: Boolean },
    showCopyBtn: { type: Boolean },
    isLoading: { type: Boolean },
    altStyle: { type: Boolean },
    showSpinner: { type: Boolean },
    minValue: {}
  },
  emits: ["blur", "input", "change", "clearInput"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const inputEl = ref();

const handleClear = (): void => {
	inputEl.value.focus();
	emit('clearInput');
};

const handleCopyText = (): void => {
	if (props.value) navigator.clipboard.writeText(props.value.toString());
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSearch)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref_key: "inputEl",
      ref: inputEl,
      value: _ctx.value,
      "aria-label": _ctx.ariaLabel || 'input field',
      placeholder: _ctx.placeholder,
      class: _normalizeClass([
				'input-field__input',
				{
					'input-field__input--error': _ctx.hasError,
					'input-field__input--search': _ctx.isSearch,
					'input-field__input--alt': _ctx.altStyle,
					'input-field__input--no-spinner': !_ctx.showSpinner,
				},
			]),
      type: _ctx.type || 'text',
      disabled: _ctx.disabled,
      min: _ctx.minValue,
      "data-ts": "input-field",
      onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('blur', $event.target.value))),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('input', $event.target.value))),
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change', $event.target.value)))
    }, null, 42, _hoisted_4),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "loading"))
      : _createCommentVNode("", true),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.errorLabel), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("button", {
      type: "button",
      title: _ctx.showClearBtn ? 'Clear' : 'Copy',
      class: _normalizeClass(['input-field__action-btn bx text-md', _ctx.showClearBtn ? ' bx-x' : 'bx-copy']),
      "aria-label": _ctx.showClearBtn ? 'Clear input' : 'Copy text',
      "data-ts": _ctx.showClearBtn ? 'clear-input-btn' : 'copy-text-btn',
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showClearBtn ? handleClear() : handleCopyText()), ["prevent"]))
    }, null, 10, _hoisted_7), [
      [_vShow, _ctx.value && ((!_ctx.disabled && _ctx.showClearBtn) || _ctx.showCopyBtn)]
    ])
  ]))
}
}

})